var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('div',[_c('img',{attrs:{"alt":"Logo","src":require("../assets/AGTEALCROPPED.png"),"width":"120","height":"120"}})])])}]

export { render, staticRenderFns }